import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, User } from 'lucide-react';

const LoginPage = () => {
    const [isLogin, setIsLogin] = useState(true);
    const [formData, setFormData] = useState({ name: '', email: '', password: '', confirmPassword: '' });
    const { setUser } = useCart();
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isLogin && formData.password !== formData.confirmPassword) {
            alert("Passwords don't match!");
            return;
        }
        // Simulate successful login/signup
        setUser({ name: formData.name || formData.email.split('@')[0], email: formData.email });
        alert(isLogin ? "Welcome back!" : "Account created successfully!");
        navigate('/');
    };

    return (
        <div className="login-container" style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'url(https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&w=1920&q=80) center/cover no-repeat',
            position: 'relative'
        }}>
            <div className="hero-overlay"></div>

            <div className="glass-panel" style={{
                width: '100%',
                maxWidth: '450px',
                padding: '3rem',
                borderRadius: '30px',
                position: 'relative',
                zIndex: 2,
                backdropFilter: 'blur(15px)'
            }}>
                <h2 style={{ fontSize: '2.5rem', marginBottom: '0.5rem', textAlign: 'center' }}>
                    {isLogin ? 'Sign In' : 'Join Us'}
                </h2>
                <p style={{ color: 'var(--text-muted)', textAlign: 'center', marginBottom: '2.5rem' }}>
                    {isLogin ? "Enter your details to access your global flavors." : "Create your account for a personalized experience."}
                </p>

                <form className="contact-form" onSubmit={handleSubmit}>
                    {!isLogin && (
                        <div style={{ position: 'relative' }}>
                            <input
                                type="text"
                                placeholder="Full Name"
                                className="input-field"
                                style={{ paddingLeft: '3rem', width: '100%' }}
                                required
                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            />
                            <User size={18} style={{ position: 'absolute', left: '1rem', top: '1.25rem', color: 'var(--primary)' }} />
                        </div>
                    )}

                    <div style={{ position: 'relative' }}>
                        <input
                            type="email"
                            placeholder="Email Address"
                            className="input-field"
                            style={{ paddingLeft: '3rem', width: '100%' }}
                            required
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        />
                        <Mail size={18} style={{ position: 'absolute', left: '1rem', top: '1.25rem', color: 'var(--primary)' }} />
                    </div>

                    <div style={{ position: 'relative' }}>
                        <input
                            type="password"
                            placeholder="Password"
                            className="input-field"
                            style={{ paddingLeft: '3rem', width: '100%' }}
                            required
                            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                        />
                        <Lock size={18} style={{ position: 'absolute', left: '1rem', top: '1.25rem', color: 'var(--primary)' }} />
                    </div>

                    {!isLogin && (
                        <div style={{ position: 'relative' }}>
                            <input
                                type="password"
                                placeholder="Confirm Password"
                                className="input-field"
                                style={{ paddingLeft: '3rem', width: '100%' }}
                                required
                                onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                            />
                            <Lock size={18} style={{ position: 'absolute', left: '1rem', top: '1.25rem', color: 'var(--primary)' }} />
                        </div>
                    )}

                    <button type="submit" className="submit-btn" style={{ marginTop: '1rem' }}>
                        {isLogin ? 'Login Now' : 'Create Account'}
                    </button>
                </form>

                <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                    <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)' }}>
                        {isLogin ? "Don't have an account?" : "Already have an account?"}
                        <span
                            onClick={() => setIsLogin(!isLogin)}
                            style={{ color: 'var(--primary)', marginLeft: '10px', cursor: 'pointer', fontWeight: '700' }}
                        >
                            {isLogin ? 'Sign Up' : 'Sign In'}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
